<template>
<div>
  <div v-for="(finding, index) in finding" :key="index">
    <div v-if="isObject(finding)">
      <p class="code-string block">
        {{ finding.file }}
      </p>
      <div v-for="(output, index) in finding.findings" :key="index">
        <span v-if="output.finding.type === 'method_call' || output.finding.type === 'static_method_call'">
          On <span class="code-integer">line {{ output.finding.lineNumber }}</span> an <span class="code-integer">{{ output.finding.identifier }}()</span> method is called.
        </span>
        <span v-if="output.childFindings">
          Subsequently 
          <span v-for="(output, index) in output.childFindings.finding" :key="index">
            on <span class="code-integer">line {{ output.lineNumber }}</span> an <span class="code-integer">{{ output.identifier }}()</span> method is called.
          </span>
        </span>
      </div>
    </div>
    <p class="code-string" v-else>{{ finding }}</p>
  </div>
</div>
</template>
<script>
export default {
  
  props: {
    finding: {
      type: Array|String,
      default: () => ({})
    },
    scraper: {
      type: Object,
      default: () => ({}),
    },
    secondaryScrapers: {
      type: Array,
      default: () => ([]),
    },
  },
  
  methods: {
    isObject(finding) {
      return finding instanceof Object
    }
  },

  computed: {
    findings() {
      return Object.entries(this.finding)
    },
    
  }

}
</script>